import type { CollaborateListView } from "../types/collaborateThread";

export type CollaborateThreadApiParams = {
  tab: "comments" | "approvals";
  filter: "all" | "open" | "mine" | "unread";
  scope: "mine" | "requested" | "all";
};

/** Map UI list view to collaborate thread list query params. */
export function listViewToApiParams(listView: CollaborateListView): CollaborateThreadApiParams {
  switch (listView) {
    case "all-approvals":
      return { tab: "approvals", filter: "all", scope: "all" };
    case "pending-mine":
      return { tab: "approvals", filter: "all", scope: "mine" };
    case "requested-by-me":
      return { tab: "approvals", filter: "all", scope: "requested" };
    case "unread":
      return { tab: "comments", filter: "unread", scope: "mine" };
    case "mentions":
      // Mentions filtered client-side until API adds a dedicated filter.
      return { tab: "comments", filter: "all", scope: "mine" };
    case "comments":
    default:
      return { tab: "comments", filter: "all", scope: "mine" };
  }
}
